module.exports = __webpack_public_path__ + "img/Screen1.ed01f9a2.png";